import { Spinner } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { IMandatesStore } from '../../stores/MandatesStore';
import WarningNotice from '../invoice/notices/WarningNotice';

interface IMandatesProviderProps {
  mandatesStore?: IMandatesStore;
  render: () => React.ReactChild | React.ReactChild[];
}

@inject('mandatesStore')
@observer
export default class MandatesProvider extends React.Component<IMandatesProviderProps> {
  public componentDidMount(): void {
    this.props.mandatesStore.tryLoadMandate();
  }

  public render(): React.ReactChild | React.ReactChild[] {
    const mandate = this.props.mandatesStore.mandate;

    if (mandate.isInitialLoading) {
      return <Spinner />;
    }

    if (mandate.isFinishedWithError) {
      return <WarningNotice translationKey="invoices.errors.failed-to-load-page" />;
    }

    return this.props.render();
  }
}
